"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../ControlRendererContext"));
const animatedGetValueWithTry_1 = __importDefault(require("../../shared/animatedGetValueWithTry"));
const initializeAnimationValue = (Animated) => {
    const value = (0, animatedGetValueWithTry_1.default)(() => new Animated.Value(0));
    if (!value) {
        return undefined;
    }
    const upAnimation = Animated.timing(value, {
        toValue: -30,
        duration: 150,
        useNativeDriver: false,
    });
    const downAnimation = Animated.timing(value, {
        toValue: 0,
        duration: 150,
        useNativeDriver: false,
    });
    let dowTimeout;
    let isUpActive = false;
    const reportChanging = () => {
        if (dowTimeout) {
            clearTimeout(dowTimeout);
        }
        if (!isUpActive) {
            upAnimation.start();
            isUpActive = true;
        }
        dowTimeout = setTimeout(() => {
            isUpActive = false;
            downAnimation.start();
        }, 300);
    };
    return {
        value,
        reportChanging,
    };
};
const MapControlCentralMarker = react_1.default.forwardRef(({ centralIconURL, shouldShowCentralIcon, }, markerApi) => {
    const { Render, Animated, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const [animation] = (0, react_1.useState)(() => initializeAnimationValue(Animated));
    (0, react_1.useImperativeHandle)(markerApi, () => ({
        reportChanging: () => {
            animation === null || animation === void 0 ? void 0 : animation.reportChanging();
        },
    }), [animation]);
    if (!shouldShowCentralIcon) {
        return null;
    }
    return (react_1.default.createElement(Render.View, { style: {
            position: 'absolute',
            marginLeft: -25,
            marginTop: -50,
            left: '50%',
            top: '50%',
            width: 50,
            height: 50,
            backgroundColor: 'transparent',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        } },
        react_1.default.createElement(Render.AnimatedImage, { resizeMode: "contain", style: {
                margin: 0,
                marginTop: animation === null || animation === void 0 ? void 0 : animation.value,
                width: '100%',
                height: 50,
                backgroundColor: 'transparent',
            }, source: centralIconURL ? {
                uri: centralIconURL,
            } : {
                uri: 'https://firebasestorage.googleapis.com/v0/b/apphive-inc.appspot.com/o/resources%2Fmedia%2FapphiveIcons%2FApphiveMapMarker.png?alt=media&token=d18f4b86-e32a-4efd-986f-5756fdadd970',
            } }),
        react_1.default.createElement(Render.View, { style: {
                position: 'absolute',
                bottom: 0,
                width: 13,
                height: 7,
                backgroundColor: 'rgba(128, 128, 128, 0.3)',
                borderRadius: 50,
            } })));
});
exports.default = MapControlCentralMarker;
